import type { PaymentOrders } from './PaymentsOrders';

export const base: PaymentOrders = {
    newBundleCollectiveList: {
        enabled: false,
        _description:
            'Enables bundle collective menu item in order list page and replaces file transfer menu item',
    },
    signingExpirationCounter: {
        enabled: true,
        _description: 'Enables expiration counter on signing page',
    },
    legacyPaymentsFetch: {
        enabled: false,
        _description:
            'Enables legacy fetch of payment orders by merging active+finished into one response payload',
    },
    useFocusPage: {
        enabled: false,
        _description: 'Turn on focus page for payment orders',
    },
    donations: {
        enabled: false,
        _description: 'Enables donations on retail web',
    },
    datacarrier: {
        asyncUpload: {
            enabled: false,
            _description: 'Enables async upload for datacarrier',
        },
    },
    instantPaymentFailover: {
        enabled: false,
        _description:
            'Enables IP failover options (execute as standard transfer / reject) when Instant Payment is selected',
    },
};
